import React from "react";
import DashboardCards from "../components/DashboardCards";
import PageTitle from "./PageTitle";


const Dashboard = () => {
    return (
        <>
            <PageTitle
                title="Dashboard"                
            />

            {/* Top White Card */}
            <div className="bg-white shadow-md rounded-xl p-5 mb-6">
                <DashboardCards />
            </div>
        </>
    );
};

export default Dashboard;
